<%= form_with(model: answer, class: "contents") do |form| %>
  <% if answer.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(answer.errors.count, "error") %> prohibited this answer from being saved:</h2>

      <ul class="list-disc ml-6">
        <% answer.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :person_id %>
    <%= form.text_field :person_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": answer.errors[:person_id].none?, "border-red-400 focus:outline-red-600": answer.errors[:person_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :question_id %>
    <%= form.text_field :question_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": answer.errors[:question_id].none?, "border-red-400 focus:outline-red-600": answer.errors[:question_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :answer_value %>
    <%= form.textarea :answer_value, rows: 4, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": answer.errors[:answer_value].none?, "border-red-400 focus:outline-red-600": answer.errors[:answer_value].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
